module.exports = __webpack_public_path__ + "media/images/app/trust/iconOne-971a624f9aa5960286d2c2bdeeac9bf4.webp";